class SelectInput {
  constructor() {
    this._init();
  }

  _init() {
    const selects = document.querySelectorAll('select');
    selects.forEach((select) => {
      select.addEventListener('change', function () {
        const value = select.value;
        if (value !== '') {
          select.classList.add('is-selected');
        } else {
          select.classList.remove('is-selected');
        }
      });
    });
  }
}

export const selectInput = new SelectInput();
